import { PodcastCreationRequest } from 'anchor-server-common/models/podcastCreationRequest';
import { Host } from '../../../../screens/DistributionScreen/types';
import { getApiUrl } from '../../../Url';

export type FetchDistributionDataParameters = {
  currentUserId: number;
};

export type HostUrls = Record<Host, string>;

type PodcastDistributionStatus =
  | 'doesNotHaveEpisode'
  | 'didNotDistributeAndHasNotSetUp'
  | 'didNotDistributeAndHasSetUp'
  | 'didNotDistributeAndHasInsertedLinks'
  | 'didDistributeAndDoesNotHaveLinks'
  | 'didDistributeAndHasInsertedLinks'
  | 'didDistributeAndWasRejected'
  | 'didImportButDidNotRedirect';

export type FetchDistributionDataResponse = {
  externalUrls: HostUrls;
  isUserEmailInRss: boolean;
  podcastCreationRequest?: PodcastCreationRequest;
  podcastDistributionStatus: PodcastDistributionStatus;
  podcastExternalSourceRedirected: string;
  podcastItunesOwnerCode?: string;
  podcastRedirectDestination?: string;
  rssFeedUrl: string;
};

export async function fetchDistributionData({
  currentUserId,
}: FetchDistributionDataParameters): Promise<FetchDistributionDataResponse> {
  try {
    const response = await fetch(
      getApiUrl({
        path: `settings/user/distribution`,
        queryParameters: {
          userId: currentUserId,
        },
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Could not fetch distribution data`);
  } catch (err) {
    throw new Error(err.message);
  }
}
